import { render, staticRenderFns } from "./AdminTableCheckbox.vue?vue&type=template&id=1bbfb992&scoped=true&"
import script from "./AdminTableCheckbox.vue?vue&type=script&lang=js&"
export * from "./AdminTableCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AdminTableCheckbox.vue?vue&type=style&index=0&id=1bbfb992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../src/web/assets/admintable/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbfb992",
  null
  
)

export default component.exports